// getters
const controlaccesoreports = state => state.controlaccesoreports

export default {
  controlaccesoreports
}



// WEBPACK FOOTER //
// ./src/store/modules/controlacceso/reports/getters.js